export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7030.1ed548fd.jpg";